import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { principalProviderParser } from '#validation';
export const GroupResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    provider: principalProviderParser,
    memberCount: z.number(),
});
export class GroupResponseDto extends createZodDto(GroupResponseSchema) {
}
